export function buildMemberGroupMap(groups) {
  const map = {};
  if (!Array.isArray(groups)) return map;
  for (const group of groups) {
    if (!group?.name || !Array.isArray(group.members)) continue;
    for (const memberId of group.members) {
      const key = typeof memberId === "string" ? memberId : memberId?.toString();
      if (!key) continue;
      if (!map[key]) map[key] = [];
      map[key].push(group.name);
    }
  }
  return map;
}

export function getGroupNamesForMember(memberId, memberGroupMap) {
  if (!memberId || !memberGroupMap) return [];
  const key = typeof memberId === "string" ? memberId : memberId?.toString();
  return memberGroupMap[key] || [];
}

export function formatMemberWithGroups(member, memberGroupMap, fallback = "No Name") {
  const baseName = member?.name || fallback;
  const names = getGroupNamesForMember(member?._id, memberGroupMap);
  if (names.length === 0) return baseName;
  return `${baseName} (${names.join(", ")})`;
}

export function formatMemberWithGroupsByIdentification(
  row,
  members,
  memberGroupMap,
  fallback = "No Name"
) {
  const baseName = row?.name || fallback;
  if (!row?.identification || !Array.isArray(members)) return baseName;
  const match = members.find((m) => m?.identification === row.identification);
  if (!match) return baseName;
  const names = getGroupNamesForMember(match._id, memberGroupMap);
  if (names.length === 0) return baseName;
  return `${baseName} (${names.join(", ")})`;
}
